import { css } from '@emotion/react'
export const propertyPageContainer = () => css`
  width: 100%;
  height: 100%;

  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const contentWrapper = css`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  position: relative;
`

export const innerContentWrapper = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
`

export const mapContainer = css`
  width: 100%;
  height: 100%;
  position: relative;
`

export const sideDrawerContainer = css`
  position: relative;
  top: 0;
  left: 0;
  z-index: 20;
`
